export default "__VITE_ASSET__4de15211__"